export const slugify = (str: string): string =>
  str
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-.]/g, "")
    .replace(/[\s_-]+/g, "-")
    .replace(/\./g, "-")
    .replace(/^-+|-+$/g, "");
